import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MegamenuComponent } from '../megamenu/megamenu.component';
import { FooterComponent } from '../footer/footer.component';
import { CompanyConfigService, CompanyConfig } from '../../services/company-config.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css',
  imports: [
    CommonModule,
    MegamenuComponent,
    FooterComponent
  ]
})
export class PrivacyPolicyComponent {
  config: CompanyConfig;

  constructor(private companyConfig: CompanyConfigService) {
    this.config = this.companyConfig.getConfig();
  }
}